interface LogoProps {
  size?: number;
  className?: string;
}

export function Logo({ size = 34, className = '' }: LogoProps) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-hs-md bg-hs-primary shadow-hs-brand ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg width={size * 0.59} height={size * 0.59} viewBox="0 0 24 24" role="img" aria-label="Hey Be Sure">
        <path
          fill="#fff"
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        />
        <circle cx="17.5" cy="17.5" r="5.3" fill="#E89A5C" />
        <path
          d="M15.3 17.6l1.4 1.4 2.6-2.8"
          fill="none"
          stroke="#fff"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

export function Wordmark({ className = '' }: { className?: string }) {
  return (
    <span className={`font-display font-bold tracking-hs-tight text-hs-text ${className}`}>
      Hey <span className="text-hs-primary">Be</span> Sure
    </span>
  );
}

export function Brand({ className = '' }: { className?: string }) {
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <Logo />
      <Wordmark className="text-[17px]" />
    </span>
  );
}
